/* ============================================================
   Dathent — tourSteps.js (TASK-145, issue #238)
   Step config for ProductTour.jsx. Each entry:
     { id, selector, titleKey, bodyKey, screen }
   - selector: a CSS selector matched against document.querySelector on the
     CURRENT page. ProductTour never navigates the user between screens to
     "complete" a step — it only lights up chrome that is already mounted
     (Sidebar/Topbar render on every /app/* route via AppShell) or the
     Dashboard's own greeting row (visible right after the tour's trigger
     point, the first /app visit). If a selector isn't found, the step is
     skipped silently — no throw, no dead-end tooltip pointing at nothing.
   - screen: the route the highlighted control lives on / leads to. It is
     METADATA ONLY (surfaced in code comments / funnel props for later
     analysis) — the engine does not call navigate() with it. Keeping the
     tour non-navigating is deliberate for this MVP: it can run start-to-
     finish from wherever the user lands without fighting whatever screen
     they're actually looking at.
   - titleKey / bodyKey: i18n keys under `productTour.steps.*` in
     src/i18n/locales/<lng>/common.json (en/ru/uk written by hand; the other
     7 locales fall back to en via i18next fallbackLng, same pattern as
     every other partially-translated surface in this app).

   Selectors were grepped from the REAL markup, not guessed:
     .dash-top-row      -> src/screens/Dashboard.jsx (Greeting row)
     .sb-cta             -> src/components/AppShell/Sidebar.jsx ("+ New post")
     a[href="/app/calendar"]  -> Sidebar.jsx NAV item (NavLink renders <a>)
     a[href="/app/settings"]  -> Sidebar.jsx secondary nav item
     a[href="/app/brandkit"]  -> Sidebar.jsx MEDIA_NAV, flag-gated by
                                  brandKitEnabled() — when the flag is off the
                                  link isn't rendered at all, so this step
                                  quietly disappears with zero extra code.
     .nbell-btn          -> src/components/AppShell/NotificationBell.jsx
   ============================================================ */

export const TOUR_STEPS = [
  {
    id: 'dashboard',
    selector: '.dash-top-row',
    titleKey: 'productTour.steps.dashboard.title',
    bodyKey: 'productTour.steps.dashboard.body',
    screen: '/app',
  },
  {
    id: 'create-post',
    selector: '.sb-cta',
    titleKey: 'productTour.steps.createPost.title',
    bodyKey: 'productTour.steps.createPost.body',
    screen: '/app/create',
  },
  {
    id: 'calendar',
    selector: 'a[href="/app/calendar"]',
    titleKey: 'productTour.steps.calendar.title',
    bodyKey: 'productTour.steps.calendar.body',
    screen: '/app/calendar',
  },
  {
    id: 'social',
    selector: 'a[href="/app/settings"]',
    titleKey: 'productTour.steps.social.title',
    bodyKey: 'productTour.steps.social.body',
    screen: '/app/settings?tab=accounts',
  },
  {
    id: 'media',
    selector: 'a[href="/app/brandkit"]',
    titleKey: 'productTour.steps.media.title',
    bodyKey: 'productTour.steps.media.body',
    screen: '/app/brandkit',
  },
  {
    id: 'notifications',
    selector: '.nbell-btn',
    titleKey: 'productTour.steps.notifications.title',
    bodyKey: 'productTour.steps.notifications.body',
    screen: null,
  },
];

export default TOUR_STEPS;
